import React, { Component } from 'react';
import { List, Edit, Create, Datagrid, SimpleForm, Filter, required,
		TextField, BooleanField, UrlField, DateField,
		TextInput, BooleanInput, NumberInput, SelectInput, ReferenceInput, LongTextInput, DisabledInput,
		EditButton, DeleteButton, CreateButton, RefreshButton  } from 'admin-on-rest';
import { CardActions } from 'material-ui/Card';
import FlatButton from 'material-ui/FlatButton';
import RefreshIcon from 'material-ui/svg-icons/navigation/refresh';
import Snackbar from 'material-ui/Snackbar';
import AdsByCustomerButton from './AdsByCustomerButton';
import { API_BASE_URL } from '../endpoints';

class RefreshActivityButton extends Component {
    state = { busy: false, snackbar: { open: false, msg: '' } };

    onClick = () => {
        this.setState({ busy: true });
        fetch(`${API_BASE_URL}/admin/customers/refresh_activity`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        })
            .then((r) => r.json().then((j) => ({ ok: r.ok, body: j })))
            .then(({ ok, body }) => {
                if (!ok) throw new Error(body.error || 'Vernieuwen mislukt');
                this.setState({ busy: false, snackbar: { open: true, msg: `${body.users_updated} gebruikers bijgewerkt` } });
                window.location.reload();
            })
            .catch((err) => this.setState({ busy: false, snackbar: { open: true, msg: err.message } }));
    };

    render() {
        return [
            <FlatButton
                key="btn"
                label={this.state.busy ? 'Bezig...' : 'Vernieuw activiteit'}
                icon={<RefreshIcon />}
                disabled={this.state.busy}
                onClick={this.onClick}
            />,
            <Snackbar
                key="snack"
                open={this.state.snackbar.open}
                message={this.state.snackbar.msg}
                autoHideDuration={3000}
                onRequestClose={() => this.setState({ snackbar: { open: false, msg: '' } })}
            />,
        ];
    }
}

const CustomersListActions = ({ resource, filters, displayedFilters, filterValues, basePath, showFilter }) => (
    <CardActions>
        {filters && React.cloneElement(filters, { resource, showFilter, displayedFilters, filterValues, context: 'button' })}
        <RefreshActivityButton />
        <CreateButton basePath={basePath} />
        <RefreshButton />
    </CardActions>
);

const ActivityFilter = (props) => (
    <Filter {...props}>
        <SelectInput
            source="activity"
            label="Activiteit"
            alwaysOn
            allowEmpty={false}
            defaultValue="active"
            choices={[
                { id: 'active',   name: 'Actief (kliks ≤ 6 mnd)' },
                { id: 'inactive', name: 'Inactief (geen kliks > 6 mnd)' },
                { id: 'all',      name: 'Alle' },
            ]}
        />
    </Filter>
);

export const CustomersList = (props) => (
    <List
        title="Portal gebruikers"
        {...props}
        perPage={50}
        filters={<ActivityFilter />}
        filterDefaultValues={{ activity: 'active' }}
        actions={<CustomersListActions />}
    >
        <Datagrid>
            <TextField source="company_name" label="Bedrijf" sortable={false} />
            <TextField source="email" sortable={false} />
            <DateField source="last_click_at" label="Laatste klik" sortable={false} />
            <EditButton />
            <DeleteButton />
        </Datagrid>
    </List>
);

export const CustomersCreate = (props) => (
    <Create {...props}>
        <SimpleForm>
            <span>ID dat overéén moet komen met ID in sites gebruikt</span>
			<TextInput source="customerdomainid" />
			
            <TextInput source="email" />
            <TextInput source="password" />
            <TextInput source="company_name" />
            <TextInput source="company_site" />
			
            <TextInput source="address_street" />
            <TextInput source="address_zip" />
            <TextInput source="address_unitnr" />
            <TextInput source="address_city" />
            <TextInput source="company_phone" />
            <TextInput source="cpc_bonus" />
			
            <LongTextInput source="dashboardmessage" />
			
			
        </SimpleForm>
    </Create>
);

export const CustomersEdit = (props) => (
    <Edit title="Edit" {...props}>
        <SimpleForm>
            <span>ID dat overéén moet komen met ID in sites gebruikt</span>
			<TextInput source="customerdomainid" />


			<TextInput source="email" />
            <TextInput source="password" />
            <TextInput source="company_name" />
            <TextInput source="company_site" />

            <TextInput source="address_street" />
            <TextInput source="address_zip" />
            <TextInput source="address_unitnr" />
            <TextInput source="address_city" />
            <TextInput source="company_phone" />
            <TextInput source="cpc_bonus" />
            <LongTextInput source="dashboardmessage" />

            <span style={{ marginTop: '1.5em', fontWeight: 'bold' }}>Silvasoft koppeling (facturatie)</span>
            <span style={{ fontSize: 12, color: '#666' }}>Tip: koppel via de pagina "Facturatie" — daar staat een dropdown met al je Silvasoft-klanten.</span>
            <NumberInput source="silvasoft_relation_id" label="Silvasoft CustomerNumber" />
            <TextInput source="silvasoft_relation_name" label="Silvasoft klantnaam (cache)" />
            <TextInput source="silvasoft_relation_country" label="Land (2-letter, bv NL/BE)" />
            <TextInput source="invoice_line_label" label="Factuurregel-omschrijving (override)" />
            <NumberInput source="invoice_tax_pc" label="BTW % (default 21)" />
        </SimpleForm>
    </Edit>
);


// WEBPACK FOOTER //
// ./src/customers/Customers.js